import { render, staticRenderFns } from "./ListingFavoritesTracker.vue?vue&type=template&id=228484f8&scoped=true&lang=pug&"
import script from "./ListingFavoritesTracker.vue?vue&type=script&lang=js&"
export * from "./ListingFavoritesTracker.vue?vue&type=script&lang=js&"
import style0 from "./ListingFavoritesTracker.vue?vue&type=style&index=0&id=228484f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228484f8",
  null
  
)

export default component.exports